import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";
import { getFacilityId, getcompanyId } from '../../utility/tokenUtility';
import { useNavigate } from 'react-router-dom';
import {
      Box,
      IconButton,
      Typography,
      Tooltip 
} from "@mui/material";
import React, { useState } from 'react';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import WorkOrderRescheduleList from "./workOrderRescheduleList";
import PageTitle from "../commoncomponents/PageTitle";
function WorkOrderRescheduleMain() {
      const facilityId = getFacilityId();
      const companyId = getcompanyId();
      const navigate = useNavigate();
      const handleHomeClick = () => {
        navigate('/dashboard'); // Adjust the path as needed
      };
      return (
            <>
                  <BreadcrumbBar>
                        <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>                   
                                    <PageTitle title={"Work Order Reschedule"} />
                        </Box>
                  </BreadcrumbBar>
                  <WorkOrderRescheduleList facilityId={facilityId} companyId={companyId}/>
            </>
      );
}

export default WorkOrderRescheduleMain;
